import React from 'react';
export const BottomInputComponent = props => {
  const {
    children,
    label,
    onClick
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: onClick
  }, label && /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, label), children));
};